var SearchWidget = function (config) {
  this.minCharacters = config.minCharacters || 3;
  this.$input = $(config.input);
  this.$results = $(config.results);
  this.$input.on("keyup", function (evt) {
    if (evt.target.value.length > this.minCharacters) {
      this.search(evt.target.value);
    }
  }.bind(this));
};
SearchWidget.prototype.search = function (searchStr) {
  //todo: cancel first request if exist
  jQuery.ajax({
    url: "/shop/search/text",
    method: "post",
    data: JSON.stringify({search: searchStr}),
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      this.$results.html(resp.results);
      this.$results.show();
    }.bind(this)
  })
};
$(function () {
  new SearchWidget({
    minCharacters: 3,
    input: 'header .searchForm input',
    results: 'header .search_results'
  });
  new SearchWidget({
    minCharacters: 3,
    input: '.mobile_search .searchForm input',
    results: '.mobile_search .search_results'
  });
});